import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { Form } from './components'

import useFetch from 'hooks/useFetch'
import usePhishing from 'hooks/usePhishing'
import useSnackbar from 'hooks/useSnackbar'
import * as service from 'service'
import { history } from 'service'
import { routes } from 'Routes'

const PhishingEdit = () => {
  const { phishingId } = useParams()
  const { setPhishing, setActiveStep, setLastActiveStep, setIsReadOnly } =
    usePhishing()
  const snackbar = useSnackbar()

  const { response, error, isLoading } = useFetch(
    service.dponet.phishingCampaigns.show,
    phishingId,
  )

  useEffect(() => {
    if (!response) return
    const campaign = response?.data?.phishingCampaign

    if (!campaign) {
      history.push(routes.phishing.all)
      return
    }

    const recipients = (campaign.recipientGroups || []).flatMap(
      (group) => group.users,
    )

    setPhishing({ ...campaign, recipients })
    setIsReadOnly(false)

    const step = campaign.journeyStep ?? 0
    setActiveStep(step)
    setLastActiveStep(step)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response])

  useEffect(() => {
    if (!error) return
    snackbar.open({
      message: 'Erro ao carregar campanha.',
      variant: 'error',
    })
    history.push(routes.phishing.all)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return (
    <Page title="Editar Campanha">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="Editar Campanha" />
        {!isLoading && <Form />}
      </Container>
    </Page>
  )
}

export default PhishingEdit
